import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useGeneral, useInfo } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastBlock',
  setup(__props) {

const { handleToast } = useGeneral();
const { getBgImg } = useInfo();
const { toast } = storeToRefs(useGeneral());

const timer = ref<ReturnType<typeof setTimeout> | null>(null);

function hideToast() {
  if (timer.value) clearTimeout(timer.value);
  if (toast.value.keepAlive) return;
  handleToast(false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_unref(toast).show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mask', 'toast', { msg: _unref(toast).keepAlive }])
          }, [
            _createElementVNode("div", {
              ref: "toastRef",
              class: "toast-inner",
              style: _normalizeStyle(_unref(getBgImg)('toast') || '')
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(toast).text), 1)
            ], 4)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})